import axios from '@/lib/axios';
import type {
  TConsentState,
  TRequisites,
  TRequisitesRead,
  TSaveRequisitesResponse,
  TSigningResponse,
} from '@/features/consent/types';

export const getConsent = async (): Promise<TConsentState> => {
  const response = await axios.get('/api/user/consent');

  return response.data.data;
}

// Возвращает null, если фотограф ещё ничего не заполнял.
export const getRequisites = async (): Promise<TRequisitesRead | null> => {
  const response = await axios.get('/api/user/consent/requisites');

  return response.data.data ?? null;
}

export const saveRequisites = async (payload: TRequisites): Promise<TSaveRequisitesResponse> => {
  const response = await axios.post('/api/user/consent/requisites', payload);

  return response.data.data;
}

// Повторный вызов безопасен: пока прежняя ссылка жива, вернётся она же.
export const startSigning = async (): Promise<TSigningResponse> => {
  const response = await axios.post('/api/user/consent/sign');

  return response.data.data;
}

// Подписанный PDF приходит потоком, а не presigned-ссылкой: внутри паспортные
// данные, а ссылка осела бы в истории браузера и логах прокси.
export const downloadConsentDocument = async (): Promise<{ blob: Blob, filename: string }> => {
  const response = await axios.get('/api/user/consent/document', { responseType: 'blob' });

  return {
    blob: response.data,
    filename: filenameFromDisposition(response.headers['content-disposition']),
  };
}

// API живёт на другом origin, и без Access-Control-Expose-Headers заголовок сюда
// не доедет — поэтому имя файла всегда с запасным вариантом.
const filenameFromDisposition = (disposition?: string) => {
  const match = disposition?.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);

  return match ? decodeURIComponent(match[1]) : 'soglasie.pdf';
}

// При responseType: 'blob' тело ошибки тоже приходит блобом, и обычное
// error.response.data.code не читается — разбираем текстом.
export const documentErrorCode = async (error: any): Promise<string | undefined> => {
  const data = error?.response?.data;

  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    try {
      return JSON.parse(await data.text())?.code;
    } catch {
      return undefined;
    }
  }

  return data?.code;
}
